import masterData from "./masterData";
import { getCampaignPrice } from "./masterUtil";
import * as serverConfig from "../config/serverConfig";

const inRange = (value, range) => {
  return (
    range.value &&
    (range.minValue == null || value >= range.minValue) &&
    (range.maxValue == null || value <= range.maxValue)
  );
};

const toKey = item => item && item.key;

class Api {
  rootUri = serverConfig.rootUri;
  apiUri = serverConfig.apiUri;
  async detail(assetId) {
    const response = await fetch(`${this.apiUri}/asset/detail/${assetId}/`, {
      credentials: "same-origin",
    });
    const asset = response.ok ? await response.json() : null;

    if (!asset || !asset.assetId) {
      return null;
    }

    const startTime = new Date().getTime();
    // floor情報をまとめる
    const floorMap = {};
    for (const room of asset.rooms || []) {
      if (!(room.floor in floorMap)) {
        floorMap[room.floor] = {
          floorId: room.floor,
          floorImg: [room.floorImg],
        };
      } else if (floorMap[room.floor].floorImg.indexOf(room.floorImg) === -1) {
        floorMap[room.floor].floorImg.push(room.floorImg);
      }
    }
    asset.floors = Object.keys(floorMap)
      .sort()
      .map(floorId => floorMap[floorId]);
    asset.floorBySlug = floorMap;


    for (const room of asset.rooms || []) {
      // campaignを適用する
      room.campaignPrice = getCampaignPrice(room);
      // 検索用の価格 effectivePriceを設定する
      // 空室のときのみ、キャンペーンを適用した価格とする。
      if (masterData.vacant.isContractable(room.vacant)) {
        room.effectivePrice = room.campaignPrice || room.price;
      } else {
        room.effectivePrice = room.price;
      }
      // 検索用の広さのkey
      room.extentKey = toKey(
        masterData.extent.list.find(extent => inRange(room.extent, extent))
      );
      // 検索用の価格のkey
      room.priceKey = toKey(
        masterData.price.list.find(price => inRange(room.effectivePrice, price))
      );
      // 検索用の寸法のkey
      room.widthKey = toKey(
        masterData.dimension.list.find(dimension =>
          inRange(room.width, dimension)
        )
      );
      // 検索用の寸法のkey
      room.heightKey = toKey(
        masterData.dimension.list.find(dimension =>
          inRange(room.height, dimension)
        )
      );
      // 検索用の寸法のkey
      room.depthKey = toKey(
        masterData.dimension.list.find(dimension =>
          inRange(room.depth, dimension)
        )
      );
      // 検索用の容積
      room.volume = room.height * room.width * room.depth;
    }
    // APIの変更を古いものに合わせる
    for (const station of asset.stations || []) {
      station.slug = station.slug || station.lineSlug;
      station.stationId = station.stationId || station.station;
    }
    // トランクハウス24を考慮した、assetTypeDigestを設定する
    if (asset.premium) {
      asset.assetIcon = "premium";
    } else {
      asset.assetIcon = asset.assetType;
    }
    if (asset.primaryCampaign !== undefined && asset.primaryCampaign !== null && asset.primaryCampaign !== "") {
      asset.assetIcon = asset.assetType + 'Campaign';
    }
    console.log("api asset detail", asset, new Date().getTime() - startTime);
    return asset;
  }
  assetImageUrl(assetId, imageId, imageIndex) {
    if (imageIndex < 5) {
      return `${this.rootUri}/bukken_img/${assetId}/${imageId}`;
    } else {
      return `${this.rootUri}/bukken_img2/${assetId}/${imageId}`;
    }
  }
  roomOpImageUrl(assetId, roomId, imageId) {
    return `${this.rootUri}/st_article_op_img/${assetId}/${roomId}/${imageId}`;
  }
  async simulation({ room, asset, params }) {
    const searchParams = new URLSearchParams();
//  const WITH_WARANTY = 1;
    const queryParams = {
      contractCd: asset.assetType === "okunai" ? "01" : "02",
      rent: room.price,
      assetId: asset.assetId,
      roomId: room.roomId,
      campaignCd: params.campaign,
      contractType: params.contractType,
      warrantyFlg: params.warrantyFlg,
      startYear: new Date(params.startDate).getFullYear(),
      startMonth: new Date(params.startDate).getMonth() + 1,
      startDate: new Date(params.startDate).getDate(),
      extend: room.extent,
      rakuraku: params.rakuraku,
      rakurakuJou: params.rakurakuJou,
      packing: params.packing,
      cardboard: params.cardboard,
      cardboardM: params.cardboardM,
      cardboardL: params.cardboardL,
      felicaCardFlg: params.felicaCardFlg,
      felicaCardCount: params.felicaCardCount,
      rackService: params.rackService,
      rackSmall: params.rackSmall,
      rackMedium: params.rackMedium,
      rackBig: params.rackBig,
      rackHanger: params.rackHanger,
      caster: params.caster,
      storageCase: params.storageCase,
      storageboxSmall: params.storageboxSmall,
      storageboxMedium: params.storageboxMedium,
    };
    for (const key of Object.keys(queryParams)) {
      if (queryParams[key] != null) {
        searchParams.append(key, queryParams[key]);
      }
    }
    const url = `${this.apiUri}/asset/simulation/?${searchParams}`;
    const response = await fetch(url, {
      credentials: "same-origin",
    });
    const simulation = response.ok && await response.json() || null;
    return simulation;
  }
  madorizuImageUrl(floorIamgeId) {
    return `${this.rootUri}/madorizu_img/${floorIamgeId}`;
  }
}
const api = new Api();
export default api;



// WEBPACK FOOTER //
// ./lib/api.js